let pdfMakePromise: Promise<any> | undefined;
let xlsxPromise: Promise<any> | undefined;

// The libraries are loaded once and cached. A failed load is not cached so that the next call retries.
export function loadPdfMake(): Promise<any> {
  pdfMakePromise ??= Promise.all([import("pdfmake/build/pdfmake"), import("pdfmake/build/vfs_fonts")])
    .then(([pdfMake, pdfFonts]) => {
      (<any>pdfMake).addVirtualFileSystem(pdfFonts);
      return pdfMake;
    })
    .catch((error) => {
      pdfMakePromise = undefined;
      throw error;
    });
  return pdfMakePromise;
}

export function loadXlsx(): Promise<any> {
  xlsxPromise ??= import("../../../lib/xlsx.full.min.js")
    .then((xlsx: any) => xlsx.default)
    .catch((error) => {
      xlsxPromise = undefined;
      throw error;
    });
  return xlsxPromise;
}

// Downloads the heavy libraries in the background when the browser is idle
export function prefetchHeavyLibs() {
  const prefetch = () => {
    loadPdfMake().catch(() => {});
    loadXlsx().catch(() => {});
  };
  if ("requestIdleCallback" in window) {
    requestIdleCallback(prefetch, {timeout: 10000});
  } else {
    setTimeout(prefetch, 3000);
  }
}
